module.exports = __webpack_public_path__ + "img/red-rectangle-table-6.eeb8a765.png";